<template>
  <div class="col-12" style="height:77vh">
    <tabs type="primary" style="display: flex;
    flex-direction: column;height:100%" tab-nav-wrapper-classes="illustration-tabs-link" class="illustration-tabs" v-model="activeTab">
      <tab-pane label="Images" style="text-align: center;height:100%" v-if="help && help.images && help.images.length > 0" @TabChange="onTabChange">
        <carousel style="width: 100%;" :per-page="1" :autoplay="false" v-if="help.images.length > 1">
          <slide v-for="image in help.images" :key="image.id">
            <dynamic-image :file-id="image.id" image-style="height: 50vh; max-width: 100%">
            </dynamic-image>
          </slide>
        </carousel>
        <dynamic-image v-else :file-id="help.images[0].id" image-style="height: 50vh; max-width: 100%">
        </dynamic-image>
      </tab-pane>

      <tab-pane label="Video" style="text-align: center;height:100%" v-if="help && help.video && help.video.id">
        <dynamic-video video-style="height: 50vh; max-width: 100%;" :file-id="help.video.id" :options="{ autoplay: true}" loop>
        </dynamic-video>
      </tab-pane>

      <tab-pane label="Info" style="text-align: center;height:100%" v-if="help && help.info">
        <div style="height: 100%; padding-bottom: 1em; overflow: scroll;">
          <p> {{ help.info }}</p>
        </div>
      </tab-pane>

    </tabs>
  </div>

</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import { TabPane, Tabs } from "src/components";
export default {
  components: { Carousel, Slide, TabPane, Tabs },

  data() {
    return { activeTab: "Images" };
  },

  mounted() {
    if (
      (!this.help.images || this.help.images.length == 0) &&
      this.help.video &&
      this.help.video.id
    ) {
      this.onTabChange("Video");
    } else if (
      (!this.help.images || this.help.images.length == 0) &&
      (!this.help.video || !this.help.video.id)
    ) {
      this.onTabChange("Info");
    }
    console.log(this.help);
  },

  computed: {
    help() {
      return this.$store.state.vitalsHelp;
    },
  },

  methods: {
    onTabChange(label) {
      this.activeTab = label;
    },
  },
};
</script>

<style scoped>
/deep/ .radial-progress-container {
  margin: auto;
}
/deep/ .illustration-tabs-link {
  order: 2;
}
/deep/ .illustration-tabs ul.nav.nav-pills {
  justify-content: space-between;
}
/deep/ .illustration-tabs .nav-pills .nav-item .nav-link {
  padding: 10px 22px;
  /* border: 1px solid; */
}
/deep/ .illustration-tabs .nav-pills .nav-item {
  margin: 0.5em;
}
/deep/ .illustration-tabs .tab-content {
  height: 27rem;
}
/deep/.illustration-tabs .tab-space {
  padding-bottom: 0px;
  height: 100%;
}
/deep/ .btn.btn-icon.btn-lg {
  height: 5.6rem;
  width: 5.6rem;
  border-radius: 50%;
}
#order-med-card {
  background-size: cover;
  background-repeat: no-repeat;
}

/deep/ iframe {
  width: 100%;
  height: 16em;
}
.video-thumbnail {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}
.playing-video-title {
  font-weight: 600;
  margin-top: 1rem;
}
.videos-list {
  overflow-y: scroll;
  height: 54vh;
}
/deep/.el-loading-spinner {
  position: fixed;
}

/deep/ .el-loading-mask {
  background: #fff !important;
}

@media (min-width: 992px) {
  iframe {
    height: 31em;
  }
}

@media (min-height: 736px) {
  /deep/ iframe {
    height: 35vh;
  }

  .videos-list {
    height: 40vh;
  }
}

@media (min-height: 768px) {
  /deep/ iframe {
    height: 40vh;
  }

  .videos-list {
    height: 40vh;
  }
}

@media (min-height: 1024px) {
  iframe {
    height: 31em;
  }
  .videos-list {
    height: 46vh;
  }
}

/*Exercise start countdown*/

.countdown {
  position: relative;
  width: 100%;
  height: 400px;
  transform-style: preserve-3d;
  perspective: 1000px;
}

.countdown:before {
  content: "";
  position: absolute;
  bottom: -50px;
  left: 0;
  width: 100%;
  height: 10px;
  background: #000;
  border-radius: 50%;
  filter: blur(14px);
  animation: shadow 1s linear infinite;
}

@keyframes shadow {
  0%,
  100% {
    transform: scale(0.5);
  }

  50% {
    transform: scale(1);
  }
}

.countdown .number {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotateY(270deg);
  animation: animate 6s linear infinite;
}

.countdown .number:nth-child(1) {
  animation-delay: 0s;
}

.countdown .number:nth-child(2) {
  animation-delay: 1s;
}

.countdown .number:nth-child(3) {
  animation-delay: 2s;
}

.countdown .number:nth-child(4) {
  animation-delay: 3s;
}

.countdown .number:nth-child(5) {
  animation-delay: 4s;
}

.countdown .number h2 {
  margin: 0;
  padding: 0;
  font-size: 8em;
  color: var(--color-primary);
}

@keyframes animate {
  0% {
    transform: rotateY(90deg);
  }

  10%,
  100% {
    transform: rotateY(-90deg);
  }
}
</style>
